import {
  call,
  cancel,
  delay,
  put,
  retry,
  select,
  takeEvery,
  takeLatest
}                                           from 'redux-saga/effects';
import { CAMERAS_CLEAR_PANE }               from "../../constants/cameras";
import {
  getEndTimeSimple,
  getStartTime
}                                           from "../../hooks/useGettimelineForPane";
import service                              from '../../services';
import { Routes }                           from '../../types'
import {
  checkCayugaStripType,
  concatByTime,
  createStrip
}                                           from '../../utils';
import { serviceTypeEnum }                  from '../API/types';
import {
  addTimeStripBkm,
  getBookmarks,
  timestripErrorBkm,
  timestripIsFetchingBkm
}                                           from "../bookmarks/actions";
import {
  bwsAddTimeStrips,
  bwsEndTimestripIsFetching,
  bwsTimestripError,
  bwsTimestripIsFetching
}                                           from "../browse/actions";
import { openWarningException }             from "../layouts/actions";
import { getTimeline as getTimelineAction } from "../timeline/actions";
import {
  chooseServiceGenerator,
  transformCayugaData
}                                           from './utils';

function* ocularisGetTimelineLoop(token, pane, startTime, endTime, continuationId) {
  let strips, continueId;
  const {browsePanes} = yield select(state => state.browse);
  const {bookmarks} = yield select(state => state.bookmarks);
  const {location} = yield select(state => state.router);

  const isBrowse = location.pathname === Routes.browse;
  const fetchActionCreator = isBrowse ? bwsTimestripIsFetching : timestripIsFetchingBkm;
  const errorActionCreator = isBrowse ? bwsTimestripError : timestripErrorBkm;
  const addActionCreator = isBrowse ? bwsAddTimeStrips : addTimeStripBkm;

  const panes = isBrowse ? browsePanes : bookmarks;
  const id = panes[pane] ? panes[pane].id : 0;

  const timestrips = panes[pane] && panes[pane].timestrips ? panes[pane].timestrips : null;
  if (panes[pane] && panes[pane].timeStripFetch) return;

  yield put(fetchActionCreator(pane));

  try {
    // const { segments, continuation_id } = yield apply(service, service.getTimeLine, [{token, pane, startTime,
    // endTime, continuationId}]);
    const {segments, continuation_id} = yield retry(5, 1000, service.getTimeLine, {
      token,
      pane,
      startTime,
      endTime,
      continuationId
    });
    continueId = continuation_id;

    const isUncertainType = () => {
      for (let segment of segments) {
        for (let strip of segment.strips) {
          if (strip.type === 3) {
            return true;
          }
        }
      }
      return false;
    }

    if (isUncertainType()) {
      yield put(bwsEndTimestripIsFetching(pane));
      yield put(getTimelineAction(pane, startTime, endTime, continuation_id));
    }
    if (segments) {
      strips = segments
        .reduce((hash, obj) => {
          obj.strips.map(strip => hash.push(strip));
          return hash;
        }, [])
        .sort((first, second) => second.low - first.low);
    }

    if (!segments || strips.length === 0) {
      if (!strips) {
        strips = [];
        yield put(openWarningException('Smth wrong in getting time line'))
      }
      strips.push(createStrip(startTime, endTime, 5));
    } else {
      if (strips[0].low > startTime) {
        strips.unshift(createStrip(startTime, strips[0].low, 5));
      }
      const i = strips.length - 1;
      if (strips[i].high < endTime && (Date.now() - endTime > 180000)) {
        strips.push(createStrip(strips[i].high, endTime, 5))
      }
    }
  } catch (e) {
    yield put(errorActionCreator(pane));
    console.error(e);
    // yield put(getTimelineAction(pane, startTime, endTime));
    // yield put(openWarningException('Error in getting time line'));
  } finally {
    if (strips) {
      const resultStrips = timestrips ? strips.concat(timestrips) : strips;
      const parsedStrips = concatByTime(resultStrips);
      parsedStrips.sort((first, second) => second.type - first.type);
      yield put(addActionCreator(pane, parsedStrips, continueId));
    }
  }
}

function* cayugaGetTimelineLoop(token, pane, startTime, endTime, continuationId) {
  let strips, continueId;
  const {browsePanes} = yield select(state => state.browse);
  const {bookmarks} = yield select(state => state.bookmarks);
  const {location} = yield select(state => state.router);

  const isBrowse = location.pathname === Routes.browse;
  const fetchActionCreator = isBrowse ? bwsTimestripIsFetching : timestripIsFetchingBkm;
  const errorActionCreator = isBrowse ? bwsTimestripError : timestripErrorBkm;
  const addActionCreator = isBrowse ? bwsAddTimeStrips : addTimeStripBkm;

  const panes = isBrowse ? browsePanes : bookmarks;
  const id = panes[pane] ? panes[pane].id : 0;

  const timestrips = panes[pane] && panes[pane].timestrips ? panes[pane].timestrips : null;
  if (panes[pane] && panes[pane].timeStripFetch) return;

  yield put(fetchActionCreator(pane));

  try {
    // const { segments, continuation_id } = yield apply(service, service.getTimeLine, [{token, pane, startTime,
    // endTime, continuationId}]);
    let res = yield retry(5, 1000, service.getTimeLine, {token, camId: id});
    if (res.error) {
      throw 'Get timeline error';
    }
    res = transformCayugaData(res.data);
    const segments = Array.isArray(res['archiverange'])
      ? res['archiverange'].map(range => ({
        high: parseInt(range['a:End']),
        low: parseInt(range['a:Begin']),
        type: checkCayugaStripType(parseInt(range['a:Type']))
      }))
      : [{
        low: parseInt(res['archiverange']['a:Begin']),
        high: parseInt(res['archiverange']['a:End']),
        type: checkCayugaStripType(parseInt(res['archiverange']['a:Type']))
      }];

    if (segments) {
      strips = segments

        .sort((first, second) => second.low - first.low);
    }

    if (!segments || strips.length === 0) {
      if (!strips) {
        strips = [];
        yield put(openWarningException('Smth wrong in getting time line'))
      }
      strips.push(createStrip(startTime, endTime, 5));
    } else {
      if (strips[0].low > startTime) {
        strips.unshift(createStrip(startTime, strips[0].low, 5));
      }
      const i = strips.length - 1;
      if (strips[i].high < endTime && (Date.now() - endTime > 180000)) {
        strips.push(createStrip(strips[i].high, endTime, 5))
      }
    }
  } catch (e) {
    yield put(errorActionCreator(pane));
    console.error(e);
    // yield put(getTimelineAction(pane, startTime, endTime));
    // yield put(openWarningException('Error in getting time line'));
  } finally {
    if (strips) {
      const resultStrips = timestrips ? strips.concat(timestrips.filter(strip => strip.type !== 1)) : strips;
      const parsedStrips = concatByTime(resultStrips);
      parsedStrips.sort((first, second) => second.type - first.type);
      yield put(addActionCreator(pane, parsedStrips, continueId));

      yield put(getBookmarks(pane));

    }
  }
}

export function* getOcularisTimeline(action) {
  const token = window.localStorage.getItem('token');
  const {pane, startTime, endTime, continuation_id} = action;

  try {
    yield call(ocularisGetTimelineLoop, token, pane, startTime, endTime, continuation_id);
  } catch (e) {
    // console.log(e)
  }
}

export function* getCayugaTimeline(action) {
  const token = window.localStorage.getItem('token');
  const {pane, startTime, endTime, continuation_id} = action;

  try {
    yield call(cayugaGetTimelineLoop, token, pane, startTime, endTime, continuation_id);
  } catch (e) {
    console.log(e)
  }
}


function* updateTimeline(action) {
  const token = window.localStorage.getItem('token');
  const {time} = yield select(state => state.timeline);
  const startTime = getStartTime(time);
  const endTime = getEndTimeSimple(time);
  const {continuation_id, pane} = action;

  if (continuation_id !== null) {
    try {
      if (window.CONFIG.ServerType === serviceTypeEnum.ocularis) {
        yield call(ocularisGetTimelineLoop, token, pane, startTime, endTime, continuation_id);
      } else {
        yield call(cayugaGetTimelineLoop, token, pane, startTime, endTime);
      }
    } catch (e) {
      console.log(e);
    } finally {
      yield delay(500);
    }
  }
}

function* cancelAndReinit(oldTasks) {
  yield cancel([...oldTasks]);
  const newTimelineTask = yield takeEvery('getTimeline', chooseServiceGenerator,
    {fn: getOcularisTimeline, args: []},
    {fn: getCayugaTimeline, args: []}
  );
  const newTimestripsTask = yield takeEvery('browseAddTimeStrips', updateTimeline);
  yield takeLatest(CAMERAS_CLEAR_PANE, cancelAndReinit, [newTimelineTask, newTimestripsTask]);
}

export default function* (action) {
  const timelineTask = yield takeEvery('getTimeline', chooseServiceGenerator,
    {fn: getOcularisTimeline, args: []},
    {fn: getCayugaTimeline, args: []}
  );
  const timestripsTask = yield takeEvery('browseAddTimeStrips', chooseServiceGenerator,
    {fn: updateTimeline, args: []},
    {fn: () => {}, args: []}
  );

  yield takeLatest(CAMERAS_CLEAR_PANE, cancelAndReinit, [timelineTask, timestripsTask]);
}